export enum PlannedOrderChannel {
  CREATE = 'plannedOrder::create',
  EDIT = 'plannedOrder::patch',
  DELETE = 'plannedOrder::delete',
}
